import React, { Component } from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import NpsFeedback from './NpsFeedback';

const TRACEABILITY_FEEDBACK_INFO_PROPERTY =
  'TRACEABILITY_FEEDBACK_INFO_PROPERTY';

const TRACEABILITY_FEEDBACK_INFO_PROPERTY_SURVEY_FLAG =
  'TRACEABILITY_FEEDBACK_INFO_PROPERTY_SURVEY_FLAG';

const TRACEABILITY_FEEDBACK_INFO_PROPERTY_VISIT_FLAG =
  'TRACEABILITY_FEEDBACK_INFO_PROPERTY_VISIT_FLAG';

export default class TraceabilityFeedback extends Component {
  onFeedbackSubmit = async (feedback: any) => {
    const message = `Rating: ${feedback.feedbackScore}, Comment: ${feedback.writtenFeedback}`;
    await StorageOfUniqueServices.get('FeedbackService').sendFeedback(
      TRACEABILITY_FEEDBACK_INFO_PROPERTY,
      message
    );
  };

  render() {
    return (
      <NpsFeedback
        question='Traceability report helps me track bugs and test executions'
        statement=''
        onFeedbackSubmit={this.onFeedbackSubmit}
        surveyShowFlagVariableName={
          TRACEABILITY_FEEDBACK_INFO_PROPERTY_SURVEY_FLAG
        }
        firstVisitFlagVariableName={
          TRACEABILITY_FEEDBACK_INFO_PROPERTY_VISIT_FLAG
        }
      />
    );
  }
}
